export default __webpack_public_path__ + "static/media/circleCheck.e640bc60.svg";